import styled from 'styled-components';
import { TopBar } from '../NavigationBar/TopBar';

const Title = styled.div`
    flex-grow: 1;
    text-align: center;
    color: ${props => props.theme.textColor};
`;

interface Props {
    className?: string;
    title?: string;
}

export const GenericTopBar: React.FC<Props> = ({ className = '', title = '' }) => {
    return (
        <TopBar
            className={className}
            showSidebarTrigger={false}
            renderCenter={() => <Title>{title}</Title>}
            renderRightSection={() => <div></div>}
        />
    );
};
